<template>
  <div
    class="modal fade"
    id="versionInfoWModal"
    tabindex="-1"
    aria-labelledby="versionInfoWModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              앱 버전 등록하기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalPartTitle">앱 버전 정보 등록</div>
            <div class="modalInputDiv">
              <label for="">앱 유형<span class="requiredSpan">*</span></label>
              <select v-model="appType" style="
                width: 60%;
                border-radius: 5px;
                border-width: 1px;
                height: 35px;" id="device"
              >
                <option value="" selected>유형 선택</option>
                <option :value=key v-for="(item, key) in appTypesList">{{ item }}</option>
              </select>
            </div>
            <div class="modalInputDiv">
              <label for="">디바이스<span class="requiredSpan">*</span></label>
              <select v-model="device" style="
                width: 60%;
                border-radius: 5px;
                border-width: 1px;
                height: 35px;" id="device"
              >
                <option value="" selected>디바이스 선택</option>
                <option :value=key v-for="(item, key) in devicesList">{{ item }}</option>
              </select>
            </div>
            <div class="modalInputDiv">
              <label for="">버전<span class="requiredSpan">*</span></label>
              <div class="version-container">
                <input type="number" v-model="version.first" :min="0" @input="validateNumber" />
                <input type="number" v-model="version.middle" :min="0" @input="validateNumber" />
                <input type="number" v-model="version.last" :min="0" @input="validateNumber" />
              </div>
            </div>
            <!-- <div class="modalInputDiv">
              <label for="">버전</label>
              <input
                type="text"
                placeholder="버전을 입력하세요."
                v-model="version"
              />
              <div class="modalInputRight"/>
            </div> -->
            <div class="modalInputDiv">
              <label for="">강제 업데이트 여부<span class="requiredSpan">*</span></label>
              <div class="radioWrap">
                <div class="radioObj">
                  <input 
                    type="radio" 
                    :value="'Y'"
                    id="forcedYW"
                    v-model="forceUpdateYn"
                  /> 
                  <label for="forcedYW">예</label>
                </div>
                <div class="radioObj">
                  <input 
                    type="radio" 
                    :value="'N'"
                    id="forcedNW"
                    v-model="forceUpdateYn"
                  /> 
                  <label for="forcedNW">아니오</label>
                </div>
              </div>
              <div class="modalInputRight"/>
            </div>
            <div class="modalInputDiv">
              <label for="">패치노트</label>
              <textarea style="
                  width: 60%;
                  border-radius: 5px;
                  border-width: 1px;
                  height: 75px;
                  resize: none;
                  " v-model="patchNote">
              </textarea>
            </div>
            <div class="modalInputDiv">
              <label for="">라이브 버전 여부<span class="requiredSpan">*</span></label>
              <div class="radioWrap">
                <div class="radioObj">
                  <input 
                    type="radio" 
                    :value="'Y'"
                    id="liveYW"
                    v-model="liveVersionYn"
                  /> 
                  <label for="liveYW">예</label>
                </div>
                <div class="radioObj">
                  <input 
                    type="radio" 
                    :value="'N'"
                    id="liveNW"
                    v-model="liveVersionYn"
                  /> 
                  <label for="liveNW">아니오</label>
                </div>
              </div>
              <div class="modalInputRight"/>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="addVersion()"
          >
            등록하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openDialog } from "../../utils/utils";
import { devices, appTypes } from "@/enums/common.enums";

export default {
  data() {
    return {
      appTypesList: [], // 앱 유형 가져오기
      devicesList: [], // 기기 종류 가져오기
      appType: "", // 앱 유형
      device: "", // 디바이스
      version: {
        first: 1,
        middle: 0,
        last: 0,
      }, // 버전
      forceUpdateYn: "", // 강제 업데이트 여부
      patchNote: "", // 패치노트
      liveVersionYn: "", // 라이브 버전 여부
    };
  },
  computed: {
    computedVersion() {
      const { first, middle, last } = this.version;
      return `${first}.${middle}.${last}`;
    },
  },
  async mounted() {
    this.appTypesList = appTypes;
    this.devicesList = devices;
    this.initValues();
  },
  methods: {
    validateNumber(event) {
      const value = event.target.value;
      if (!isNaN(value)) {
        event.target.value = value;
      } else {
        event.target.value = value.replace(/\D/g, '');
      }
    },
    // 주요 API

    // 버전 등록
    async addVersion() {
      if(await this.validateData()) {
        try {
          const obj = {};

          obj.appType = this.appType;
          obj.device = this.device;
          obj.version = this.computedVersion;
          obj.forceUpdateYn = this.forceUpdateYn;
          obj.patchNote = this.patchNote;
          obj.liveVersionYn = this.liveVersionYn;
          const response = await this.$apiInstance.post(`/appversions`, obj);
          if(response.status === 200 || response.status === 201) {
            await openDialog("앱 버전 등록이 완료되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
          } else {
            await openDialog("앱 버전 등록에 실패하였습니다.", "error", "확인");
          }

        } catch (error) {
          console.log(error);
          await openDialog("앱 버전 등록에 실패하였습니다.", "error", "확인");
        }
      }
    },

    // 업로드 전 검증
    async validateData() {
      if (!this.appType) {
        await openDialog("앱 유형을 선택해 주세요.", "error", "확인");
        return false;
      } 
      if (!this.device) {
        await openDialog("디바이스를 선택해 주세요.", "error", "확인");
        return false;
      } 
      const firstValidation = typeof this.version.first !== 'number'
      const middleValidation = typeof this.version.middle !== 'number'
      const lastValidation = typeof this.version.last !== 'number'
      if(firstValidation || middleValidation || lastValidation) {
        await openDialog("버전을 입력해 주세요.", "error", "확인");
        return false;
      } 
      if(!this.forceUpdateYn) {
        await openDialog("강제 업데이트 여부를 선택해 주세요.", "error", "확인");
        return false;
      } 
      if(!this.liveVersionYn) {
        await openDialog("라이브 버전 여부를 선택해 주세요.", "error", "확인");
        return false;
      } 
      return true;
    },


    // 기타 versionInfoW용 utils

    // 항목 초기화 용도
    initValues() {
      this.appType = "";
      this.device = "";
      this.version = {
        first: 1,
        middle: 0,
        last: 0,
      };
      this.forceUpdateYn = "";
      this.patchNote = "";
      this.liveVersionYn = "";
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/version-manage.scss';
</style>